<template>
  <section>
    <h3 class="is-size-4 has-text-weight-bold has-text-centered">Tabla de Participantes</h3>
    <div class="has-text-right" v-if="show != 'True' ">
      <b-button v-if="publication.can_edit && publication.academic_activity_state_id == 1" type="is-info"
                icon-left="edit"
                @click="editPublication">
        Editar Participantes
      </b-button>
    </div>
    <div class="column">
      <b-table
          :data="participants"
          :paginated=true
          per-page=5
          striped
          hoverable
          :current-page="currentPage"
          :card-layout="cardLayout"
          :pagination-simple=false
          pagination-position="bottom"
          default-sort-direction="desc"
          sort-icon="arrow-up"
          sort-icon-size="is-small"
          default-sort="last_patent_state_date"
          aria-next-label="Siguiente"
          aria-previous-label="Anterior"
          aria-page-label="Página"
          aria-current-label="Página actual">
        <b-table-column
            field= 'person_name'
            label= 'Nombres'
            width="15em"
            searchable
            sortable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            <a @click="goToProfile(props.row.person_id)">{{ props.row.person_name }}</a>
          </template>
        </b-table-column>
        <b-table-column
            field= 'person_mail'
            label= 'Correo Corporativo'
            searchable
            sortable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{  props.row.person_mail ? props.row.person_mail.toUpperCase() : '' }}
          </template>
        </b-table-column>
        <b-table-column
            field= 'unit_name'
            label= 'Unidad'
            searchable
            sortable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{  props.row.unit_name }}
          </template>
        </b-table-column>
        <b-table-column
            label="Tipo de Participación"
            v-slot="props">
          <template>
            {{  props.row.participant_type }}
          </template>
        </b-table-column>
        <template slot="empty" slot-scope="props">
          <div class="columns is-centered">
            <div class="column is-6 is-centered has-text-centered">
              <b-message type="is-danger">
                No se encontraron participantes.
              </b-message>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
    <b-modal
        :active="isComponentModalActive"
        width="90%"
        :can-cancel="canCancel"
        aria-modal>
      <template #default="props">
        <new-book-form modal-cancel="true"
                              :cargo-principal="cargoPrincipal"
                              :user-id="userId"
                              :show-participants-first="true"
                              modal-header="Editar Libro"
                              query-type="update" v-bind:book-id="publication.id" @close="closeModal"></new-book-form>
      </template>
    </b-modal>

    <b-modal
        :active="isComponentModalInbookActive"
        width="90%"
        :can-cancel="canCancel"
        aria-modal>
      <template #default="props">
        <new-inbook-form modal-cancel="true"
                              :cargo-principal="cargoPrincipal"
                              :user-id="userId"
                              :show-participants-first="true"
                              modal-header="Editar"
                              query-type="update" v-bind:inbook-id="publication.id" @close="closeModal"></new-inbook-form>
      </template>
    </b-modal>

  </section>
</template>

<script>
import axios from "axios";
import newBookForm from './NewBookForm';
import newInbookForm from './NewInbookForm';
export default {
  name: "ShowParticipantsTab",
  props:[ 'participants', 'publication', 'cargoPrincipal', 'canEdit', 'userId', 'show'],
  components:{newBookForm, newInbookForm},
  data(){
    return{
      isLoading:false,
      currentPage:1,
      cardLayout:false,
      defaultOpenedDetails: [1],
      showDetailIcon: true,
      years:[],
      year:null,
      isComponentModalActive:false,
      isComponentModalInbookActive: false,
      canCancel: ['escape']
    }
  },
  created(){

  },
  methods:{
    editPublication(){
      if( this.publication.publication_type==="Book"){
        this.isComponentModalActive = true; 
      }
      else{
        this.isComponentModalInbookActive = true;
      }
    },
    closeModal(){
      this.isComponentModalActive = false;
      this.isComponentModalInbookActive = false;
    },
    goToProfile(id){
      window.location.href='/people/'+id
    },
  }

}
</script>

<style scoped>

</style>